import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const ConfirmationPage = ({ fields }) => (
  <div>
    <p>ConfirmationPage Component</p>
    <Text field={fields.heading} />
  </div>
);

export default ConfirmationPage;
